import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, CircularProgress, Alert } from '@mui/material';
import CaseFolder from '../../components/Cases/CaseFolder';
import { getAuthToken } from '../../lib/authToken';

const CaseFolderPage: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>();

  const { data: caseData, isLoading, error } = useQuery({
    queryKey: ['case', caseId],
    queryFn: async () => {
      const token = getAuthToken();
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`/api/cases/${caseId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch case');
      }

      return response.json();
    },
    enabled: !!caseId,
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    console.error('Case folder error:', error);
    return (
      <Alert severity="error">
        Failed to load case. Please try again.
      </Alert>
    );
  }

  if (!caseData?.data) {
    return (
      <Alert severity="error">
        Case not found
      </Alert>
    );
  }

  return (
    <CaseFolder 
      caseId={caseId!} 
      caseData={caseData.data} 
    />
  );
};

export default CaseFolderPage; 